import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_JobselectionBB = () => (
  <DAAModuleSubtopic
    title="Branch and Bound - Job Sequencing and Assignment"
    videos={[
      "https://www.youtube.com/embed/3RBNPc0_Q6g?list=PLDN4rrl48XKpZkf03iYFl-O29szjTrs_O",
      "https://www.youtube.com/embed/M7Fl_z7_J2k?list=PLDN4rrl48XKpZkf03iYFl-O29szjTrs_O",
      "https://www.youtube.com/embed/WiC2dmPnFPU?list=PLLykrwdi1zxEdk8lqJxZ0m-UFuf0x46Fp",
    ]}
    takeaways={[
      { text: "Practice all three methods: LIFO-BB, FIFO-BB, and Least Cost BB method." },
      { text: "Queue helps in systematically exploring the state space tree." },
      { text: "Tuple representation ensures efficient state management." },
      { text: "Priority Queue (Best-First) improves efficiency." },
      { text: "Bound calculation prunes unnecessary computations." },
    ]}
    questions={[
      {
        text: "Apply the Branch and Bound method to solve the Job Sequencing Problem for the given set of jobs.",
        image: "/jobq1.png",
      },
      {
        text: "Solve the Job Sequencing Problem using FIFO-BB. Select an optimal subset J with an optimal penalty for the given data. What will be the penalty corresponding to the optimal solution? Discuss how a queue is used in the state space tree using fixed tuple representation.",
        image: "jobq2.png",
      },
      {
        text: "Given the number of jobs n=4, penalties (p1, p2, p3, p4) = (5, 10, 6, 4), deadlines (d1, d2, d3, d4) = (1, 2, 2, 1), and execution times (t1, t2, t3, t4) = (1, 2, 1, 2). Find the actual cost and feasible jobs done using the Branch and Bound technique.",
      },
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/TGXzwEpTqe0",
      "https://www.youtube.com/embed/bZLvbg-dkzQ",
      "https://www.youtube.com/embed/TxGdI7HAfhg",
    ]}
  />
);

export default DAA_JobselectionBB ;
